<!--盖章文件-->
<template>
	<div>
		<el-card v-if="isShowFile" header="投保盖章文件" style="margin-bottom: 15px">
			<avue-form
				ref="fileForm"
				v-model="formFileConfirm"
				:option="optionFileConfirm"
				:upload-before="onUploadBefore"
				@submit="onSubmitFileConfirm">
				<template #insureConfirmUrl="{}">
					<el-button type="primary" @click="onDownLoadTemp">下载模板</el-button>
				</template>
				<template #menuForm="{}">
					<el-button v-if="isSubmitted" icon="el-icon-edit" @click="onEditFileConfirm">修改</el-button>
				</template>
			</avue-form>
		</el-card>
	</div>
</template>

<script>
import {FileConfirmOption} from '@/const/crud/insurance/unitOption'
import {openPdfUrl} from '@/util/util'
import {calcPremium, checkUnit} from '@/api/insurance/policy'
import {isFgkDoor, isFgkGuangfu, isGetGaiZhangProductId} from '@/util/productUtil'
import _ from 'lodash'
import {toYYYYmmdd} from '@/util/date'

export default {
	name: 'fileConfirm',
	data() {
		return {
			formFileConfirm: {
				insureConfirmFile: '',
				insureConfirmSample: '',
				insureConfirmUrl: '',
			},
			optionFileConfirm: this.deepClone(FileConfirmOption),
			isSubmitted: false,
			isShowFile: false,
			unitFormData: {},
			//存储盖章文件
			fileConfirmMap: new Map(),
			lastPlanType: 0,
		}
	},
	props: {
		productId: {
			type: String | Number,
			required: true,
		},
		insureType: {
			type: Number | String,
			required: true,
		},
	},
	mounted() {
		this.onGetFileConfirm = _.debounce(this.onGetFileConfirm, 500)
	},
	activated() {
		//处理监听
		this.$Bus.$on('onBusFileConfirm', this.onGetFileConfirm)
	},
	deactivated() {
		this.$Bus.$off('onBusFileConfirm', this.onGetFileConfirm)
	},
	methods: {
		onUploadBefore({type = '', size = 0}, done, loading) {
			if (type !== 'image/jpeg' && type !== 'image/png') {
				this.$message.error('上传图片只支持JPEG或PNG格式!')
				loading()
				return
			}
			if (size / 1024 / 1024 > 5) {
				this.$message.error('请上传大小不超过5Mb的jpg/png文件')
				loading()
				return
			}
			done()
		},
		onSubmitFileConfirm(form, done) {
			//根据企业信息确认数据
			if (this.validatenull(this.unitFormData)) {
				this.$message.error('企业数据有误！')
				done()
				return
			}
			this.unitFormData.productId = this.productId
			this.unitFormData.insureConfirmFile = this.formFileConfirm.insureConfirmFile
			checkUnit(this.unitFormData)
				.then((response = {}) => {
					let {code = -1, msg = '盖章文件有误！请重新上传'} = response.data || {}
					if (code === 0) {
						this.isSubmitted = true
						this.onIsSubmit(true)
					} else {
						this.$alert(msg, '提示', {confirmButtonText: '我知道了'}).then(() => {})
					}
				})
				.finally(() => {
					done()
				})
		},
		onEditFileConfirm() {
			//编辑
			this.onIsSubmit(false)
		},
		onGetFileConfirm(fileData = {}) {
			//文件数据
			let {insureConfirmSample = '', insureConfirmUrl = '', unitData = {}, interType, planType} = fileData
			// //储存数据
			if (!this.validatenull(insureConfirmUrl)) {
				this.fileConfirmMap.set(this.productId + '', {insureConfirmSample, insureConfirmUrl})
			}

			console.log('fileConfirmMap-----', fileData, this.fileConfirmMap, this.productId)
			//判断进入
			if (interType === 'unit') {
				//处理企业信息
				//传递企业过来，替换
				this.unitFormData = unitData || {}
				//有数据，则替换
				//处理盖章  不是泛高空，则直接展示
				this.onDealFile(fileData, !isFgkDoor(this.productId) && !isFgkGuangfu(this.productId))
			} else if (interType === 'plan') {
				//选择方案过来的，获取productId
				let tempId = isGetGaiZhangProductId(this.productId, planType)
				console.log('tempId-------', tempId)
				let tempFileData = this.fileConfirmMap.get(tempId + '')
				if (!this.validatenull(tempFileData)) {
					this.onDealFile(tempFileData, true)
				} else {
					//请求数据
					//如果存在企业数据，则模拟计算保费！！！！
					if (!this.validatenull(this.unitFormData)) {
						this.onGetCalcData(tempId)
					}
				}
			} else if (interType === 'entry') {
				//计算保费过来的
				this.onDealFile(fileData, true)
			}
		},
		//传递进来的不一样，则处理
		onDealFile({insureConfirmUrl = '', insureConfirmSample = ''}, isShow = false) {
			if (this.formFileConfirm.insureConfirmUrl !== insureConfirmUrl) {
				this.formFileConfirm.insureConfirmFile = ''
				this.formFileConfirm.insureConfirmSample = insureConfirmSample
				this.formFileConfirm.insureConfirmUrl = insureConfirmUrl
				if (this.isSubmitted) {
					this.onIsSubmit(false)
				}
			}
			if (this.isShowFile) {
				this.isShowFile = insureConfirmUrl !== ''
			} else {
				this.isShowFile = isShow && insureConfirmUrl !== ''
			}
		},
		//下载模板
		onDownLoadTemp() {
			openPdfUrl(this.formFileConfirm.insureConfirmUrl)
		},
		//是否确定 true 确定
		onIsSubmit(type) {
			this.isSubmitted = type
			this.optionFileConfirm.submitBtn = !type
			this.optionFileConfirm.column.forEach((item, index) => {
				if (item.prop !== 'insureConfirmSample') {
					item.disabled = type
				}
			})
		},
		//判断是否需要上传，并且上传成功
		onJudgeFileConfirm() {
			return !this.isShowFile || this.isSubmitted
		},
		getFileUrl() {
			return this.isSubmitted && this.isShowFile ? this.formFileConfirm.insureConfirmFile : ''
		},
		onGetCalcData(tempId) {
			let {unitCode, unitName, areaCode} = this.unitFormData
			let tempData = {
				order: {productType: '', effectiveDate: toYYYYmmdd(Date.now()), term: 1, addMaim: '1'},
				applicant: {unitCode: unitCode, unitName: unitName, areaCode: areaCode},
				insureAmount: 30,
				vehs: [],
				emps: [],
			}

			let tempLog = process.env.VUE_APP_RRLOG_ID || ''
			if (tempLog.includes('test')) {
				tempData.emps = isFgkDoor(this.productId)
					? [{professionId: '29828', professionCode: '0701025', insureMoney: 30}]
					: [{professionId: '29827', professionCode: '0706017', insureMoney: 30}]
			} else {
				tempData.emps = isFgkDoor(this.productId)
					? [{professionId: '29373', professionCode: '0701025', insureMoney: 30}]
					: [{professionId: '27637', professionCode: '0706017', insureMoney: 30}]
			}
			tempData.order.productType = tempId
			calcPremium(tempData).then((res = {}) => {
				let {code = -1, data = {}} = res.data
				if (code === 0) {
					let {productId, insureConfirmSample, insureConfirmUrl} = data
					this.onDealFile(data, true)
					//存储
					this.fileConfirmMap.set(productId + '', {insureConfirmSample, insureConfirmUrl})
					//模拟的计算保费 也要更改当前productID
					//替换productID,重新请求保费
					this.$emit('onChangeProductId', productId)
				}
			})
		},
	},
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload-dragger {
	width: 150px;
	border: transparent;
}
</style>
